import React, { memo, useMemo } from 'react'
import MenuBrowser from './MenuBrowser'
import { motion } from 'framer-motion'
import { getNavBrowseAllProps } from '@/domain/useCases/navBar/getNavBrowseAllProps'
import {
  LEARN_MENU_TEXT,
  RESOURCE_HUB_TEXT
} from '../../../domain/useCases/navBar/constants'
import { NavHelpItem } from './NavHelpItem'
import { Containers } from '@/domain/useCases/navBar/constants'
const conVariants = {
  hidden: {
    opacity: 1,
    translateX: '300px',
    transition: {
      duration: 0.2,
      delay: 0.2
    }
  },
  animate: {
    opacity: 1,
    translateX: '0px',
    transition: {
      duration: 0.2
    }
  },
  exit: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2
    }
  }
}

const LearnMenu = ({ setPage, container }) => {
  const containerContent = useMemo(() => {
    if (!container) return null
    const browseButtonProps = getNavBrowseAllProps(container)
    switch (container) {
      case Containers.RESOURCE_HUB:
        return (
          <NavHelpItem
            title="Resource Hub"
            bodyText={RESOURCE_HUB_TEXT}
            browseButtonProps={browseButtonProps}
          />
        )
    }
  }, [container])

  return (
    <motion.div
      key="learn-menu"
      variants={conVariants}
      initial="hidden"
      animate="animate"
    >
      <div className="flex h-full flex-col gap-y-8 overflow-y-auto bg-white px-6 pb-12">
        <MenuBrowser setPage={setPage} />
        <div>{containerContent}</div>
      </div>
    </motion.div>
  )
}

export default memo(LearnMenu)
